export default "__VITE_ASSET__FQJY4Ljx__"